import { Dispatch, SetStateAction } from 'react';
import tradingModalStore from 'global/TradingModal/store';
import handleErrorMessageAPI from 'global/AlertErrorMessage';
import create from 'zustand';
import tradingStore from 'lib/stores/trading';
import useSecuritiesCredentialStore from 'global/Securities/stores/useSecuritiesCredentialStore';
import noticeError from 'utils/logger';
import useFormulaStore from 'global/VirtualTrading/stores/useFormulaStore';
import useAuthModalStore from '../store';
import { AUTH_MODAL_CONFIG } from '../constants';

const useTradingStore = create(tradingStore);

export default function useVirtualLogin(
  setLoading: Dispatch<SetStateAction<boolean>>,
) {
  const { resetErrorCode } = useTradingStore();
  const showTradingModal = tradingModalStore((state) => state.showModal);
  const { closeModal, tradingModalConfig } = useAuthModalStore();
  const loadFormula = useFormulaStore((s) => s.loadFormula);
  const loadLoginVirtual = useSecuritiesCredentialStore(
    (s) => s.loadLoginVirtual,
  );

  const switchToVirtual = async () => {
    setLoading(true);

    try {
      await loadLoginVirtual();
      await loadFormula();

      resetErrorCode();
      handleErrorMessageAPI(
        'Kamu berhasil masuk ke Akun Virtual Trading',
        'plain-green',
      );

      if (tradingModalConfig !== null && !tradingModalConfig.onVirtualLoginSuccess) {
        showTradingModal({
          ...tradingModalConfig,
          orderType: AUTH_MODAL_CONFIG.virtual[tradingModalConfig.orderType],
        });
      }

      if (tradingModalConfig?.onVirtualLoginSuccess) {
        tradingModalConfig.onVirtualLoginSuccess();
      }

      closeModal();
    } catch (error) {
      noticeError(Error('Failed to Switch to Virtual'), {
        event: 'useVirtualLogin@switchToVirtual',
      });
    }

    setLoading(false);
  };

  return {
    switchToVirtual,
  };
}
